import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteKB } from '../../../app/services/apiEndpoints';

interface IDeleteKBPayload {
    category: string;
    index: string;
    kb: string;
    group: string;
    user_id: string;
    session_id: string;
    filename: string;
}

export const deleteKnowledgeBase = createAsyncThunk(
    'kbManage/deleteKnowledgeBase',
    async (payload: IDeleteKBPayload, thunkAPI) => {
      try {
        const queryParams = new URLSearchParams({
            category: payload.category,
            kb: payload.kb,
            index: payload.index,
            group: payload.group,
            user_id: payload.user_id,
            session_id: payload.session_id,
            filename: payload.filename,
        });
        const response = await deleteKB(queryParams);
        return response;
      } catch (error) {
        const errorMessage =
          error instanceof Error ? error.message : "An unknown error occurred";
        return thunkAPI.rejectWithValue(errorMessage);
      }
    }   
);

interface IKBManageState {
    DeleteKBError: any | null;
}

const initialState: IKBManageState = {
    DeleteKBError: null,
  };

const KBManageSlice = createSlice({
  name: 'kb-manage',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteKnowledgeBase.fulfilled, (_, action) => {
          console.log(action.payload);
      })
      .addCase(deleteKnowledgeBase.rejected, (state, action) => {
        state.DeleteKBError = action.payload;
      })
  },
});
  
export const { } = KBManageSlice.actions 
export default KBManageSlice.reducer;